var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD83D",
    d: "M18.54 14.07A8.787 8.787 0 0 1 7.658 6.695a6.857 6.857 0 1 0 10.886 7.371h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB6E04",
    d: "M18.84 12.459a8.77 8.77 0 0 1-4.843-7.02a6.86 6.86 0 0 1 4.843 7.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD83D",
    d: "M18.613 10.175c-.36-.108-.759-.24-1.218-.39c-.904-.296-2.022-.665-3.437-1.055c-2.134-.587-3.96-1.47-5.327-2.7a6.862 6.862 0 0 1 9.982 4.145"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunc);
export default __webpack_public_path__ + "static/media/lunc.8b9cb1bb159319878aeeb96c661f34f1.svg";
export { ForwardRef as ReactComponent };